import { createSelector } from "@reduxjs/toolkit";

import { discoveryPanelsSelector } from "./discoveryPanels.selector";

export const viewPortSelector = createSelector(
  discoveryPanelsSelector,
  state => state.viewPort
);